import type { Database } from '@/database.types';
import type { CheckInResponseCreate } from '@/entities/check-in-response';

type ApiCheckInResponseUpsert =
  Database['public']['Tables']['check_in_responses']['Insert'];

function toApiCheckInResponseUpsert(
  response: CheckInResponseCreate,
  userId: string,
): ApiCheckInResponseUpsert {
  return {
    user_id: userId,
    plan_id: response.planId,
    prompt_key: response.promptKey,
    prompt_text: response.promptText,
    response: response.response,
  };
}

export function createCheckInResponsesService(
  supabaseClient: typeof import('./supabase').supabaseClient,
  getUserId: () => string,
) {
  return {
    upsertCheckInResponses: async (
      responses: CheckInResponseCreate[],
    ): Promise<void> => {
      const userId = getUserId();
      const mapped = responses.map((r) =>
        toApiCheckInResponseUpsert(r, userId),
      );

      const { error } = await supabaseClient
        .from('check_in_responses')
        .upsert(mapped, { onConflict: 'plan_id,prompt_key' });

      if (error) {
        throw error;
      }
    },
  };
}
